import React from 'react';

const HourglassIcon = () => (
  <svg width="23" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.16406 18.332H15.8307"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16406 1.66797H15.8307"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1693 18.3333V14.8567C14.1692 14.4147 13.9935 13.9908 13.6809 13.6783L10.0026 10L6.32427 13.6783C6.01169 13.9908 5.83603 14.4147 5.83594 14.8567V18.3333"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83594 1.66797V5.14464C5.83603 5.58663 6.01169 6.01048 6.32427 6.32297L10.0026 10.0013L13.6809 6.32297C13.9935 6.01048 14.1692 5.58663 14.1693 5.14464V1.66797"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HourglassIcon;
